'use client';

import { useTranslation } from '@/i18n/hooks/useTranslation';
import ContactForm from '@/components/forms/ContactForm';
import BuilderPageWrapper from '@/components/builder2/BuilderPageWrapper';

function TraditionalContact() {
  const { t } = useTranslation();
  return (
    <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 bg-white dark:bg-dark-bg transition-colors duration-300'>
      <div className='text-center mb-16'>
        {/* h2: el h1 de la página lo emite `ContactSeoContent` en el servidor,
            para que no queden dos. Igual que en /consignments. */}
        <h2 className='text-3xl md:text-4xl font-bold text-gray-900 dark:text-white'>
          {t('formsUi.contactPage.title')}
        </h2>
        <p className='mt-4 text-xl text-gray-500 dark:text-gray-400'>
          {t('formsUi.contactPage.subtitle')}
        </p>
      </div>
      <ContactForm />
    </div>
  );
}

export default function ContactClient() {
  return <BuilderPageWrapper slug="contact" fallback={<TraditionalContact />} />;
}
